import Vue from "vue";
import _ from "lodash";
import API from "@/api/index";

const MODULE_NAME = "tim";

const MUTATION_TYPES = {
	SET_CONTENT_TYPES: "SET_CONTENT_TYPES",
	SET_FRAME_TYPES: "SET_FRAME_TYPES",
	SET_AREA_TYPES: "SET_AREA_TYPES",
	SET_ITIS_CODES: "SET_ITIS_CODES",
	SET_ROAD_SURFACE_DESCRIPTIONS: "SET_ROAD_SURFACE_DESCRIPTIONS",
	ADD_CONTENT_TYPES: "ADD_CONTENT_TYPES",
	ADD_FRAME_TYPES: "ADD_FRAME_TYPES",
	ADD_AREA_TYPES: "ADD_AREA_TYPES",
	CLEAR_CONTENT_TYPES: "CLEAR_CONTENT_TYPES",
	CLEAR_FRAME_TYPES: "CLEAR_FRAME_TYPES",
	CLEAR_AREA_TYPES: "CLEAR_AREA_TYPES"
};

const ACTION_TYPES = {
	FETCH_CONTENT_TYPES: "FETCH_CONTENT_TYPES",
	FETCH_FRAME_TYPES: "FETCH_FRAME_TYPES",
	FETCH_AREA_TYPES: "FETCH_AREA_TYPES",
	FETCH_ITIS_CODES: "FETCH_ITIS_CODES",
	FETCH_ROAD_SURFACE_DESCRIPTIONS: "FETCH_ROAD_SURFACE_DESCRIPTIONS"
};

const appendToArrayUnlessEmpty = (arr, o) => {
	if (_.isEmpty(o)) return;
	if (!Array.isArray(o)) o = [o];
	return _.map(o, r => arr.push(r));
};

// DRY helper
const replaceArrayAtKeyGenerator = key => {
	return (state, payload) => {
		Vue.set(state, key, payload);
	};
};

// DRY helper
const appendToArrayAtKeyGenerator = key => {
	return (state, payload) => {
		appendToArrayUnlessEmpty(state[key], payload);
	};
};

// DRY helper
const clearArrayAtKeyGenerator = key => {
	return state => {
		Vue.set(state, key, []);
	};
};

const fetchAndMutateResult = (mutation, endpoint) => {
	return context => {
		return API.getJson(endpoint)
			.then(json => {
				context.commit(mutation, json);
			})
			.catch(err => console.error(err));
	};
};

export default {
	MODULE_NAME,
	MUTATION_TYPES,
	ACTION_TYPES,
	namespaced: true,
	state: {
		contentTypes: [],
		frameTypes: [],
		areaTypes: [],
		itisCodes: [],
		roadSurfaceDescriptions: []
	},
	mutations: {
		[MUTATION_TYPES.SET_CONTENT_TYPES]: replaceArrayAtKeyGenerator(
			"contentTypes"
		),
		[MUTATION_TYPES.SET_FRAME_TYPES]: replaceArrayAtKeyGenerator("frameTypes"),
		[MUTATION_TYPES.SET_AREA_TYPES]: replaceArrayAtKeyGenerator("areaTypes"),
		[MUTATION_TYPES.SET_ITIS_CODES]: replaceArrayAtKeyGenerator("itisCodes"),
		[MUTATION_TYPES.ADD_CONTENT_TYPES]: appendToArrayAtKeyGenerator(
			"contentTypes"
		),
		[MUTATION_TYPES.ADD_FRAME_TYPES]: appendToArrayAtKeyGenerator("frameTypes"),
		[MUTATION_TYPES.ADD_AREA_TYPES]: appendToArrayAtKeyGenerator("areaTypes"),
		[MUTATION_TYPES.CLEAR_CONTENT_TYPES]: clearArrayAtKeyGenerator(
			"contentTypes"
		),
		[MUTATION_TYPES.CLEAR_FRAME_TYPES]: clearArrayAtKeyGenerator("frameTypes"),
		[MUTATION_TYPES.CLEAR_AREA_TYPES]: clearArrayAtKeyGenerator("areaTypes"),
		[MUTATION_TYPES.SET_ROAD_SURFACE_DESCRIPTIONS]: replaceArrayAtKeyGenerator(
			"roadSurfaceDescriptions"
		)
	},
	actions: {
		[ACTION_TYPES.FETCH_CONTENT_TYPES]: fetchAndMutateResult(
			MUTATION_TYPES.SET_CONTENT_TYPES,
			API.ENDPOINTS.GET_TIM_CONTENT_TYPE_LIST
		),
		[ACTION_TYPES.FETCH_FRAME_TYPES]: fetchAndMutateResult(
			MUTATION_TYPES.SET_FRAME_TYPES,
			API.ENDPOINTS.GET_TIM_FRAME_TYPE_LIST
		),
		[ACTION_TYPES.FETCH_AREA_TYPES]: fetchAndMutateResult(
			MUTATION_TYPES.SET_AREA_TYPES,
			API.ENDPOINTS.GET_TIM_AREA_TYPE_LIST
		),
		[ACTION_TYPES.FETCH_ITIS_CODES]: fetchAndMutateResult(
			MUTATION_TYPES.SET_ITIS_CODES,
			API.ENDPOINTS.GET_ITIS_CODE_LIST
		),
		[ACTION_TYPES.FETCH_ROAD_SURFACE_DESCRIPTIONS]: fetchAndMutateResult(
			MUTATION_TYPES.SET_ROAD_SURFACE_DESCRIPTIONS,
			API.ENDPOINTS.GET_ROAD_SURFACE_DESCRIPTIONS
		)
	},
	getters: {
		contentTypes: state => state.contentTypes,
		frameTypes: state => state.frameTypes,
		areaTypes: state => state.areaTypes,
		itisCodes: state => state.itisCodes,
		roadSurfaceDescriptions: state => state.roadSurfaceDescriptions
	}
};
